import { ICandidate } from '../../../interfaces/graph-types';
import { AccountService } from '../../../services/account.service';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

type onSelectCandidate = (
  candidate: ICandidate,
  onsuccess: onSmartSuccess,
  onfailure: onSmartFailure,
) => void;

@Component({
  selector: 'modal-candidate-selector',
  template: require('./modal-candidate-selector.component.pug'),
  styles: [require('./modal-candidate-selector.component.css').toString()],
})
export class ModalCandidateSelectorComponent implements OnInit {
  candidates$: Observable<ICandidate[]>;

  // Options to pass to the modal:
  accountId: string;
  onSelect: onSelectCandidate;
  onSuccess: any;
  onFailure: any;

  searchText = '';
  searchChanged: Subject<any> = new Subject<any>();

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.searchChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => this.startSearch(model));

    this.candidates$ = this.accountService.searchAccountCandidates(
      this.accountId,
      '',
    );
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {}

  // -------------------------------------------------------------------
  isLoading() {
    return false;
  }

  // -------------------------------------------------------------------
  startSearch(newvalue) {
    this.candidates$ = this.accountService.searchAccountCandidates(
      this.accountId,
      newvalue,
    );
  }

  // -------------------------------------------------------------------
  valueChanged(newvalue) {
    this.searchChanged.next(newvalue);
  }

  // -------------------------------------------------------------------
  closeModal() {
    this.onSuccess();
    this.bsModalRef.hide();
  }

  private selectedCandidate: ICandidate;

  // -------------------------------------------------------------------
  setCandidate(candidate: ICandidate) {
    this.selectedCandidate = candidate;
  }

  // -------------------------------------------------------------------
  save(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.onSelect(this.selectedCandidate, onsuccess, onfailure);
  }
}
